export default async function customFetch(url, optsObj = {}) {
  let results;
  try {
    results = await fetch(url, optsObj);
  } catch (e) {
    return {
      error: true,
      code: 418,
      res: 'Encountered an error when attempting to connect with the server. Please try again later.',
    };
  }

  let error = [400, 401, 403, 404, 419, 500].includes(results.status);
  let data = await (error ? results.text() : results.json());

  return {
    error,
    code: results.status,
    res: data,
  };
}
